export const getAggregateView = state => state.static.aggregateView;
export const getAvailableDatabases = state => state.static.availableDatabases;
export const getCurrentUser = state => state.static.currentUser;
